import React, { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import ConnectionTypeTable from "./ConnectionTypeTable";
import ConnectionTypeParameter from "./ConnectionTypeParameter";
import ConnectionTypeSpecification from "./ConnectionTypeSpecification";
import ConnectionTypeSpecificationParameter from "./ConnectionTypeSpecificationParameter";
const ConnectionType = () => {
  const { id } = useParams();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [specificationRowId, setSpecificationRowId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <>
      <div className="px-4 pt-4 mb-2 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <button
            className="mr-3 duration-300 ease-in-out hover:text-blue-900 hover:-translate-x-3"
            onClick={() => navigate("/connection")}
          >
            <BsArrowLeft className="w-6 h-6 mr-1 hover:cursor-pointer" />
          </button>
          <h3 className="text-2xl">
            {location.state.item.product1Name}-
            {location.state.item.product2Name}
          </h3>
        </div>
        <div className="grid grid-cols-6 mt-4 gap-x-5">
          <div className="col-span-6 sm:col-span-3">
            <ConnectionTypeTable
              id={id}
              selectedRowId={selectedRowId}
              setSelectedRowId={setSelectedRowId}
              setSpecificationRowId={setSpecificationRowId}
            />
          </div>
          <div className="col-span-6 sm:col-span-3">
            <ConnectionTypeParameter connectionTypeId={selectedRowId} />
          </div>
          <div className="col-span-6 sm:col-span-3">
            <ConnectionTypeSpecification
              setSpecificationRowId={setSpecificationRowId}
              connectionTypeId={selectedRowId}
            />
          </div>
          <div className="col-span-6 sm:col-span-3">
            <ConnectionTypeSpecificationParameter
              specificationId={specificationRowId}
              selectedRowId={selectedRowId}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ConnectionType;
